<template>
  <div
    :class="`
      workpacke-info-body-add
      font-weight-light
      `"
    >
      <div
        class="body-search"
        :style="`width: ${['TaktPlanAddWorkPackage', 'TaktPlanAddWBWorkPackage'].includes($route.name)?'100%':'75px'}`">
        <slot name="search"/>
      </div>
      <div
        class="body-workpackage"
        :style="`width: ${['TaktPlanAddWorkPackage', 'TaktPlanAddWBWorkPackage'].includes($route.name)?'0%':'100%'}`">
        <slot name="workpackage"/>
      </div>
  </div>
</template>
<script>
  export default {
    props: []
  }
</script>
<style>
  .workpacke-info-body-add {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 3px 3px;
    /* padding: 3px; */
    color: black;

  }
  .body-search {
    position: relative;
    transition: all 0.2s ease-in-out;
    overflow-y: hidden;
    overflow-x: hidden;
  }
  .body-workpackage {
    position: relative;
    transition: all 0.2s ease-in-out;
    overflow: auto;
    overflow-x: hidden;

  }
</style>
